export default "__VITE_ASSET__EpHWh$8g__"